/// <reference path="../../typings/tsd.d.ts" /> 
module warsApp.models {
    export class DocumentMetadataModel {

        constructor(documentDto: Wars.Domain.Model.Dtos.DocumentDto) {
            if (!documentDto) return;
            this.documentTypeUniqueId = documentDto.documentTypeUniqueId;
            this.descriptiveComment = documentDto.descriptiveComment;
            this.isSecured = documentDto.isSecured;
        }

        public documentTypeUniqueId: string;
        public descriptiveComment: string;
        public isSecured: boolean;

        public updateDocumentDto(documentDto: Wars.Domain.Model.Dtos.DocumentDto): void {
            documentDto.documentTypeUniqueId = this.documentTypeUniqueId;
            documentDto.descriptiveComment = this.descriptiveComment;
            documentDto.isSecured = this.isSecured;
        }
    }
}